/**
 * Convert `WithStringUnion<SomeEnum>` back to `SomeEnum`.
 */
export const withoutStringUnion = (value) => value;
//# sourceMappingURL=helpers.js.map